import Routes, { RoutesNames } from 'src/enums/routes';

import {
    SessionIcon,
    SettingsIcon,
    SummaryIcon,
    CourseIcon,
    WarehousingIcon,
    DiscountCodesIcon,
    SettingsIconV2,
    MySessionsIcon,
    OverviewIcon,
    JournalsIconV2,
    GenotypeIcon,
    QuestionnaireIcon,
    ReportsIcon,
    SparklesIcon,
    ProteinShakeBottle2,
} from 'src/assets/images/custom';
const CustomSupplementDetails = () => import('src/pods/sessions/components/Supplement/CustomSupplementDetails');

const Sessions = () => import('../pods/sessions/Sessions');
const SessionDetails = () => import('../pods/sessions/components/SessionDetails');
const ResultsSummary = () => import('../pods/sessions/components/resultsSummary/ResultsSummary');
const Onboarding = () => import('../pods/onboarding/Onboarding');
const Home = () => import('../pods/pages/Home');
const Journals = () => import('../pods/journals/Journals');
const JournalDetails = () => import('../pods/journals/components/JournalDetails');
const Settings = () => import('../pods/settings/Settings');
const Terms = () => import('../pods/pages/Terms');
const TermsPortal = () => import('../pods/pages/ToSPortal');
const PrivacyPolicy = () => import('../pods/pages/PrivacyPolicy');

const Warehousing = () => import('../pods/warehousing/Warehousing');
const Course = () => import('../pods/course/Course');
const Summary = () => import('../pods/summary/Summary');
const DiscountCodes = () => import('../pods/discount/DiscountCodes');

const SessionJournal = () => import('src/pods/sessions/components/journals/Journal');
const SessionResults = () => import('src/pods/sessions/components/results/Results');
const CustomerSupplements = () => import('src/pods/sessions/components/Supplement/CustomSupplements');
const SessionQuestionnaires = () => import('src/pods/sessions/components/questionnaires/Questionnaires');
const SessionResultDetails = () => import('src/pods/sessions/components/results/ResultDetails');
const SessionQuestionnaireDetails = () => import('src/pods/sessions/components/questionnaires/QuestionnaireDetails');
const Reports = () => import('src/pods/sessions/components/reports/Reports');
const AskAi = () => import('src/pods/sessions/components/askAi/AskAi');

const Transactions = () => import('src/pods/summary/components/Transactions');

export interface IRoute {
    name: string;
    path: string;
    icon: any;
    withSidebar?: boolean;
    sidebarMenu?: boolean;
    component: any;
    disabled?: boolean;
    practitionerAccepted?: boolean;
}

export const authRoutes: IRoute[] = [
    {
        name: 'Home',
        path: Routes.ROOT,
        icon: null,
        withSidebar: false,
        sidebarMenu: false,
        component: Home,
    },
    {
        name: 'Onboarding',
        path: Routes.ONBOARDING,
        icon: null,
        withSidebar: true,
        sidebarMenu: true,
        component: Onboarding,
    },
    {
        name: 'Sessions',
        path: Routes.SESSIONS,
        icon: SessionIcon,
        withSidebar: true,
        sidebarMenu: true,
        component: Sessions,
    },
    {
        name: 'Session Details',
        path: Routes.SESSION_DETAILS_ID,
        icon: null,
        withSidebar: true,
        sidebarMenu: true,
        component: SessionDetails,
    },
    {
        name: 'Results Summary',
        path: Routes.RESULTS_SUMMARY,
        icon: null,
        withSidebar: true,
        sidebarMenu: true,
        component: ResultsSummary,
    },
    {
        name: 'Journals',
        path: Routes.JOURNALS,
        icon: null,
        withSidebar: true,
        sidebarMenu: true,
        component: Journals,
    },
    {
        name: 'Edit Journal',
        path: Routes.JOURNAL_EDIT,
        icon: null,
        withSidebar: true,
        sidebarMenu: true,
        component: JournalDetails,
    },
    {
        name: 'Write in Journal',
        path: Routes.JOURNAL_WRITE,
        icon: null,
        withSidebar: true,
        sidebarMenu: true,
        component: JournalDetails,
    },

    {
        name: 'Settings',
        path: Routes.SETTINGS,
        icon: SettingsIcon,
        withSidebar: true,
        sidebarMenu: true,
        component: Settings,
    },
    {
        name: 'Terms',
        path: Routes.TERMS_AND_CONDITIONS,
        icon: null,
        withSidebar: false,
        sidebarMenu: false,
        component: Terms,
    },
    {
        name: 'Privacy and Policy',
        path: Routes.PRIVACY_POLICY,
        icon: null,
        withSidebar: false,
        sidebarMenu: false,
        component: PrivacyPolicy,
    },
    {
        name: 'Terms and Conditions',
        path: Routes.TERMS_PORTAL,
        icon: null,
        withSidebar: false,
        sidebarMenu: false,
        component: TermsPortal,
    },
    {
        name: 'Summary',
        path: Routes.SUMMARY,
        icon: SummaryIcon,
        withSidebar: true,
        sidebarMenu: true,
        component: Summary,
    },
    {
        name: 'Course',
        path: Routes.COURSE,
        icon: CourseIcon,
        withSidebar: true,
        sidebarMenu: true,
        component: Course,
    },
    {
        name: 'Warehousing',
        path: Routes.WAREHOUSING,
        icon: WarehousingIcon,
        withSidebar: true,
        sidebarMenu: true,
        component: Warehousing,
    },
    {
        name: 'Discount codes',
        path: Routes.DISCOUNT_CODES,
        icon: DiscountCodesIcon,
        withSidebar: true,
        sidebarMenu: true,
        component: DiscountCodes,
    },
    {
        name: 'Transactions',
        path: Routes.TRANSACTIONS,
        icon: SummaryIcon,
        withSidebar: true,
        sidebarMenu: true,
        component: Transactions,
    },
    {
        name: RoutesNames.SESSION_OVERVIEW,
        path: Routes.SESSION_OVERVIEW,
        icon: OverviewIcon,
        withSidebar: true,
        sidebarMenu: true,
        component: SessionDetails,
    },
    {
        name: RoutesNames.SESSION_JOURNAL,
        path: Routes.SESSION_JOURNAL,
        icon: JournalsIconV2,
        withSidebar: true,
        sidebarMenu: true,
        component: SessionJournal,
    },
    {
        name: RoutesNames.SESSION_RESULTS,
        path: Routes.SESSION_RESULTS,
        icon: GenotypeIcon,
        withSidebar: true,
        sidebarMenu: true,
        component: SessionResults,
    },
    {
        name: RoutesNames.SESSION_RESULT_ID,
        path: Routes.SESSION_RESULT_ID,
        icon: GenotypeIcon,
        withSidebar: true,
        sidebarMenu: true,
        component: SessionResultDetails,
    },
    {
        name: RoutesNames.SESSION_QUESTIONNAIRES,
        path: Routes.SESSION_QUESTIONNAIRES,
        icon: QuestionnaireIcon,
        withSidebar: true,
        sidebarMenu: true,
        component: SessionQuestionnaires,
    },
    {
        name: RoutesNames.REPORTS,
        path: Routes.REPORTS,
        icon: null,
        withSidebar: true,
        sidebarMenu: true,
        component: Reports,
    },
    {
        name: RoutesNames.SESSION_QUESTIONNAIRES_ID,
        path: Routes.SESSION_QUESTIONNAIRES_ID,
        icon: QuestionnaireIcon,
        withSidebar: true,
        sidebarMenu: true,
        component: SessionQuestionnaireDetails,
    },
    {
        name: RoutesNames.ASK_AI,
        path: Routes.ASK_AI,
        icon: SparklesIcon,
        withSidebar: true,
        sidebarMenu: true,
        component: AskAi,
    },
    {
        name: RoutesNames.CUSTOM_SUPPLEMENTS,
        path: Routes.CUSTOM_SUPPLEMENTS,
        icon: ProteinShakeBottle2,
        withSidebar: true,
        sidebarMenu: true,
        component: CustomerSupplements,
    },
    {
        name: RoutesNames.CUSTOM_SUPPLEMENTS_DETAILS_ID,
        path: Routes.CUSTOM_SUPPLEMENTS_DETAILS_ID,
        icon: ProteinShakeBottle2,
        withSidebar: true,
        sidebarMenu: true,
        component: CustomSupplementDetails,
    },
];

export const footerRoutes: IRoute[] = [
    {
        name: 'Terms',
        path: Routes.TERMS_AND_CONDITIONS,
        icon: null,
        withSidebar: false,
        sidebarMenu: false,
        component: Terms,
    },
    {
        name: 'Privacy and Security',
        path: Routes.PRIVACY_POLICY,
        icon: null,
        withSidebar: false,
        sidebarMenu: false,
        component: PrivacyPolicy,
    },
];

export const sessionSidebarRoutes: IRoute[] = [
    {
        name: RoutesNames.SESSION_OVERVIEW,
        path: Routes.SESSION_OVERVIEW,
        icon: OverviewIcon,
        withSidebar: true,
        sidebarMenu: true,
        component: SessionDetails,
    },
    {
        name: RoutesNames.SESSION_RESULTS,
        path: Routes.SESSION_RESULTS,
        icon: GenotypeIcon,
        withSidebar: true,
        sidebarMenu: true,
        component: SessionResults,
    },
    {
        name: RoutesNames.SESSION_QUESTIONNAIRES,
        path: Routes.SESSION_QUESTIONNAIRES,
        icon: QuestionnaireIcon,
        withSidebar: true,
        sidebarMenu: true,
        component: SessionQuestionnaires,
    },
    {
        name: RoutesNames.REPORTS,
        path: Routes.REPORTS,
        icon: ReportsIcon,
        withSidebar: true,
        sidebarMenu: true,
        component: Reports,
    },
    {
        name: RoutesNames.CUSTOM_SUPPLEMENTS,
        path: Routes.CUSTOM_SUPPLEMENTS,
        icon: ProteinShakeBottle2,
        withSidebar: true,
        sidebarMenu: true,
        component: CustomerSupplements,
    },
];

export const sidebarRoutes: IRoute[] = [
    {
        name: 'Summary',
        path: Routes.SUMMARY,
        icon: SummaryIcon,
        withSidebar: true,
        sidebarMenu: true,
        component: Summary,
        practitionerAccepted: true,
    },
    {
        name: 'My sessions',
        path: Routes.SESSIONS,
        icon: MySessionsIcon,
        withSidebar: true,
        sidebarMenu: true,
        component: Sessions,
        practitionerAccepted: false,
    },
    {
        name: 'Course',
        path: Routes.COURSE,
        icon: CourseIcon,
        withSidebar: true,
        sidebarMenu: true,
        component: Course,
        practitionerAccepted: false,
    },
    {
        name: 'Warehousing',
        path: Routes.WAREHOUSING,
        icon: WarehousingIcon,
        withSidebar: true,
        sidebarMenu: true,
        component: Warehousing,
        practitionerAccepted: true,
    },
    {
        name: 'Discount codes',
        path: Routes.DISCOUNT_CODES,
        icon: DiscountCodesIcon,
        withSidebar: true,
        sidebarMenu: true,
        component: DiscountCodes,
        practitionerAccepted: true,
    },
    {
        name: 'Settings',
        path: Routes.SETTINGS,
        icon: SettingsIconV2,
        withSidebar: true,
        sidebarMenu: true,
        component: Settings,
        practitionerAccepted: false,
    },
];
